import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';

export interface LocationRoomSurveyDialogData {
  title: string;
  /** Survey JSON including optional root `data` for default field values. */
  surveyJson: object;
  formReceive: string;
}

@Component({
  selector: 'app-location-room-survey-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, DynamicFormComponent],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content class="dialog-scroll">
      <app-dynamic-form [dynamicInput]="dynamicInput"></app-dynamic-form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close type="button">Annuller</button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .dialog-scroll {
        max-height: min(70vh, 640px);
        overflow: auto;
        padding-top: 8px;
      }
      h2 {
        margin: 0 0 8px;
        font-size: 1.15rem;
        font-weight: 600;
      }
    `,
  ],
})
export class LocationRoomSurveyDialogComponent {
  dynamicInput: Record<string, { type: string; value: unknown }>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LocationRoomSurveyDialogData
  ) {
    this.dynamicInput = {
      surveyJSON: {
        type: 'surveyJSON',
        value: JSON.stringify(data.surveyJson),
      },
      formReceiveFunction: { type: 'text', value: data.formReceive },
    };
  }
}
